import React from "react";
import {
  Box,
  Card,
  Inline,
  Stack,
  Text,
  TextLink,
} from "@origin-digital/ods-core";
import { formatLabel } from "@/utils";
import { sharedContent as content } from "./content.json";
import AERHousehold1 from "@/assets/aer_household_1.svg";
import AERHousehold2 from "@/assets/aer_household_2.svg";
import AERHousehold3 from "@/assets/aer_household_3.svg";
import AERHousehold4 from "@/assets/aer_household_4.svg";
import AERHousehold5 from "@/assets/aer_household_5.svg";

const householdImageMapping: Record<number, any> = {
  1: AERHousehold1,
  2: AERHousehold2,
  3: AERHousehold3,
  4: AERHousehold4,
  5: AERHousehold5,
};

export const Household = ({ numberOfPeople }: { numberOfPeople: number }) => {
  const HouseholdImage = householdImageMapping[numberOfPeople];

  return (
    <Box
      width="full"
      display="flex"
      marginLeft={{ xs: "none", lg: "xsmall" }}
      marginBottom={{ xs: "none", lg: "none" }}
    >
      <Card backgroundColor="grey50">
        <Stack space="large">
          <Inline
            space="small"
            alignY={{ xs: "center", lg: "stretch" }}
            disableWrap={true}
            direction={{ xs: "row", lg: "column" }}
          >
            {HouseholdImage && <HouseholdImage height="72px" width="72px" />}

            <Text tone={"neutralDark"}>
              {formatLabel(
                content.battery.household.description,
                (value) => (
                  <Text inline={true} variant={"subtitle-small"}>
                    <b>{value}&nbsp;person household</b>
                  </Text>
                ),
                numberOfPeople
              )}
            </Text>
          </Inline>
          <Text variant="body-small">
            {formatLabel(
              content.battery.household.finePrint,
              (value) => (
                <TextLink
                  href={content.battery.household.AERConsumptionDataLink.url}
                  target="_blank"
                >
                  {value}
                </TextLink>
              ),
              content.battery.household.AERConsumptionDataLink.text
            )}
          </Text>
        </Stack>
      </Card>
    </Box>
  );
};
